
import React from 'react';
import api from './api';
import './Doctors.css';
import {useNavigate, Link, Navigate} from "react-router-dom"
import TextScanner from './TextScanner';
import UpiPaymentQR from './UpiPaymentQR';
import useAuth from "../hooks/useAuth";
import { canDo } from '../utils/canDo';
import {useRef,  useState,useEffect} from 'react';
import CustomDataTable from './CustomDataTable';

const BillPrintReport = ({data, patientCData, onClose}) => { 
    const { auth } = useAuth();
  const [allocationSummary, setAllocationSummary] = useState([]);

  const [patients, setPatients] = useState([]);  
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [newBill, setNewBill] = useState();
  const navigate = useNavigate();
  const [therapistView, setNextScreen] = useState();
  const [selectedServices, setSelectedServices] = useState([]);
  const [init, setInit] = useState();
  const [billDetails, setBillDetails] = useState({});
  const [paid, setPaid] = useState(0);
  const [toPay, setToPay] = useState(0);
  const [balance, setBalance] = useState(0);
  const [bills, setBills] = useState([]);
  const [hide, setHideFields] = useState(false);
  const conponentPDF= useRef();
  const [transactionId, setTransactionId] = useState(null);
  const cameraRef = useRef(null);
  const [transactionDetails, setTransactionDetails] = useState({});
  const [scannedData, setScannedData] = useState(null);
const [showMoreDiscounts, setShowMoreDiscounts] = useState({});
const [selectedDiscountIndex, setSelectedDiscountIndex] = useState({}); // per bill index
const [receivedAmount, setReceivedAmount] = useState(0);
const [givenBackAmount, setGivenBackAmount] = useState(0);
const [netOutstandingBalance, setNetOutStanding] = useState(0);
const [totalOrgs, setTotalOrgs] = useState([]);
const [payments, setPayments] = useState([
  { mode: "Cash", amount: 0 },
]);

const [recvdAmountInWords, setrecvdAmountInWords] = useState('');
const [givenbackAmountInWords, setgivenbackAmountInWords] = useState('');
const [showUpiModal, setShowUpiModal] = useState(false);
const [toast, setToast] = useState(null);
const showToast = (msg, type = 'info') => {
  setToast({ msg, type });
  setTimeout(() => setToast(null), 3500);
};

const [confirmModal, setConfirmModal] = useState(null); // { msg, resolve }
const showConfirm = (msg) => new Promise(resolve => setConfirmModal({ msg, resolve }));
const handleConfirmResolve = (answer) => {
  if (confirmModal?.resolve) confirmModal.resolve(answer);
  setConfirmModal(null);
};
const [netAmountInWords, setnetAmountInWords] = useState('');

 const n = (v) => Number(v) || 0;

 const footNote = 
`*> Please call during working hours.
 > Please eat 2hrs before your session.
 > You can also access your body posture and alignment with our best of state equipments.`;

  useEffect(
      () => {
       // if (!init) {
        var ur = ""
        //console.log("auth roles =", auth.roles)
        if ( auth.roles && auth.roles.indexOf("therapist") != -1) {
            ur = "therapist/"+auth.username
            setNextScreen("")
        } 
        else if (canDo(auth, 'billing.view'))
        {
            ur="profiles" 
            console.log("bill & services are  ==", data?.bills);
            console.log("patient ==", data?.patient);
            setSelectedPatient(data.patient);
            setBills(data.bills);
            setBillDetails(data.billDetails);
            setToPay(data.billDetails.total);            
            setPaid(data.billDetails.paid);
            setBalance(data.billDetails.balance);
            //setSelectedServices(bill.services);  
            // Patient qty, therapist
            if (patientCData)
            {
              console.log("patientData = ", patientCData);
              setSelectedServices(patientCData.services);
            }
        }
      //  setInit(1);
     // }
      }, []);

useEffect(() => {

  const net = updateNetOutstanding(
    Number(billDetails?.total) || 0,
    receivedAmount,
    givenBackAmount
  );
  setNetOutStanding(Number(net).toFixed(2));
  // Convert to words safely
  const netRounded = Math.round(net);

if (!isNaN(netRounded)) {
  const inWords =
    netRounded < 0
      ? `- ${numberToWords(Math.abs(netRounded))}`
      : numberToWords(netRounded);
  setnetAmountInWords(inWords);
}

  var totalOrgs = getTotalOrgs();
  setTotalOrgs(totalOrgs);
}, [billDetails?.total, receivedAmount, givenBackAmount]);



const getTotalOrgs = () => {
  
  var dets = selectedPatient?.previousbalancedetails || [];
  
  var totalOrgs = [];
  for (var i=0; i< dets?.length; i++)
  { 
    totalOrgs.push(dets[i].org); 
  }
  console.log("total orgs = ", totalOrgs);
  return totalOrgs;
}


const updatePaymentAmount = (index, value) => {
  const updated = [...payments];
  updated[index].amount = Math.max(0, Number(value) || 0);
  setPayments(updated);

  allocateReceivedAmount(
    updated.reduce((sum, p) => sum + p.amount, 0)
  );
};

const addPaymentMode = () => {
  setPayments([...payments, { mode: "UPI", amount: 0 }]);
};

//const totalReceived = payments.reduce((sum, p) => sum + p.amount, 0);
const totalReceived = payments.reduce((sum, p) => sum + Number(p.amount || 0), 0);


  // Convert number to Indian currency words
function numberToWords(num) {
  if (!num) return '';
  const a = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
    'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
    'Seventeen', 'Eighteen', 'Nineteen'
  ];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  const numToWords = (n, suffix = '') => {
    let str = '';
    if (n > 19) str += b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
    else str += a[n];
    return str ? str + suffix : '';
  };

  const n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{3})$/);
  if (!n) return '';

  let str = '';
  str += numToWords(parseInt(n[1]), ' Crore ');
  str += numToWords(parseInt(n[2]), ' Lakh ');
  str += numToWords(parseInt(n[3]), ' Thousand ');
  str += numToWords(parseInt(n[4].substring(0, 1)), ' Hundred ');
  str += numToWords(parseInt(n[4].substring(1))) + ' Rupees';
  return str.trim();
}


function isPendingService(name) {
  return String(name).toLowerCase().includes("pending");
}

function isRefundService(name) {
  return String(name).toLowerCase().includes("refund");
}

function isSpecialService(name) {
  return isPendingService(name) || isRefundService(name);
}

  const serviceColumns = (billIndex) => [
    {
      name: "Service",
      selector: (row) => row?.name,
      sortable: true,
    },
    {
      name: "Qty",
      selector: (row) => row?.qty,
      sortable: true,
      width: "7vw !important",
    },  
    {
      name: "Amount",
      selector: (row) => row?.amount,
      sortable: true,
    },
    {
      name: "Discount",
      selector: (row) => row?.sdiscount,
      sortable: true,
      cell: (row, rowIndex, column, id) => (
       row.name.includes("Refund") ? null : (
          <input
            type="number"
            value={row.sdiscount}
            onChange={(e) => handleDiscountChange(billIndex, rowIndex, e.target.value)}
            style={{ width: "80px" }}
          />
        )
      ),
    },
  
  
    /*
    {
      name: "Description",
      selector: (row) => row?.description,
      sortable: true,
 
    },*/
  
  ];

// --- Helper function to generate printable HTML ---
function generateBillHTML(company, billIndex) {
  var todayDate = new Date();
  console.log("full company = ", company );
  var ctotal = parseInt(company.total, 10) || 0;
  var cpaid = parseInt(company.paid, 10) || 0;
  var cdiscount = parseInt(company.discount, 10) || 0;
  var ctotalbeforetax = parseInt(company.totalbeforetax, 10) || 0;

var companyNameMap = {
  "MedicalyogaTherapyCentre": "Medical Yoga Therapy Centre",
  "MedicalyogaAssociation": "Medical Yoga Association",
  "ReRoot": "Re root",
  "GoodLifeAcademy": "Good Life Academy"
}
var cname = companyNameMap[company.orgDetails.name]; 

    let total = 0;
    let totalbeforetax = 0;
    let anyigst = false;
    let anydiscount = false;
    let anycgst = false;
    let anyecess = false;

    let final = company.services.map(s => {

      let cgsttotal = 0;
      let sgsttotal = 0;  
      let igsttotal = 0;
      let ecesstotal = 0;
  
      const qty = s.qty || 1;
      //subtotal += qty * s.amount;
      totalbeforetax += qty * s.amount;
      
      if (s.sgst && s.cgst && s.sgst > 0  && s.cgst > 0) {
          cgsttotal = totalbeforetax * (s.cgst) / 100;
          sgsttotal = totalbeforetax * (s.sgst) / 100;

          total = totalbeforetax + (sgsttotal + cgsttotal);
          anycgst = true;
      }
      else if (s.igst) 
      {
          igsttotal = totalbeforetax * (s.igst) / 100;
          total = totalbeforetax + igsttotal;
          anyigst = true;
      }
      if (s.ecess) 
      {
          ecesstotal = totalbeforetax * s.ecess / 100 
          total += ecesstotal;
          anyecess = true;
      }
      if (s.sdiscount && s.sdiscount > 0) {
          total -= s.sdiscount;
          anydiscount = true;
      }
      console.log("bill row = ", s );  
      if (anycgst == false && anyigst == false)
        anycgst = true;

      return {
        ...s,
        cgsttotal: cgsttotal,
        sgsttotal: sgsttotal,
        igsttotal: igsttotal,
        ecesstotal: ecesstotal,
        totalbeforetax: totalbeforetax,
        total: total,
      }
   
  });
 // const s = company.services?.[0] || {};
return `
 <div class="receipt" style="font-family:'Segoe UI',system-ui,sans-serif; font-size:13px; color:#1e293b; border-radius:12px; overflow:hidden;">

  <!-- ══ Colored header band ══ -->
  <div style="background:linear-gradient(135deg,#1e3a8a 0%,#312e81 50%,#4c1d95 100%); padding:20px 24px; display:flex; align-items:center; gap:20px;">
    <img src="${company.orgDetails.name}.jpg" alt="${company.orgDetails.name}"
         style="height:64px; width:auto; max-width:120px; object-fit:contain; border-radius:8px; background:#fff; padding:4px;">
    <div style="flex:1; color:#fff;">
      <div style="font-size:20px; font-weight:900; letter-spacing:-0.3px;">${cname}</div>
      ${company.orgDetails.gstin ? `<div style="font-size:11px; opacity:0.75; margin-top:2px;">GSTIN: ${company.orgDetails.gstin}</div>` : ""}
      <div style="font-size:12px; opacity:0.8; margin-top:4px;">${company.orgDetails?.address || ''}</div>
      <div style="font-size:12px; opacity:0.75; margin-top:2px;">${company.orgDetails?.phone1 || ''} ${company.orgDetails?.email1 ? '| ' + company.orgDetails.email1 : ''}</div>
    </div>
    <div style="text-align:right; color:#fff;">
      <div style="font-size:10px; font-weight:700; opacity:0.65; letter-spacing:1px; margin-bottom:4px;">INVOICE</div>
      <div style="font-size:15px; font-weight:800;">${company.invoicenumber}</div>
      <div style="font-size:11px; opacity:0.75; margin-top:4px;">${todayDate.toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'})}</div>
    </div>
  </div>

  <!-- ══ Bill-to strip ══ -->
  <div style="background:#f8fafc; padding:12px 24px; display:flex; gap:40px; border-bottom:2px solid #e2e8f0;">
    <div>
      <div style="font-size:10px; font-weight:700; color:#94a3b8; letter-spacing:1px; margin-bottom:3px;">BILL TO</div>
      <div style="font-size:14px; font-weight:800; color:#1e293b;">${company?.name || ''}</div>
      <div style="font-size:12px; color:#64748b;">${company?.number || ''}</div>
    </div>
    <div>
      <div style="font-size:10px; font-weight:700; color:#94a3b8; letter-spacing:1px; margin-bottom:3px;">CASHIER</div>
      <div style="font-size:13px; font-weight:700; color:#1e293b;">${company.cashier || ''}</div>
    </div>
  </div>

  <!-- ══ Items Table ══ -->
  <div style="padding:20px 24px;">
  <table style="width:100%; border-collapse:collapse; margin-bottom:20px;">
    <thead>
      <tr style="background:linear-gradient(135deg,#1e3a8a,#4f46e5);">
        <th style="text-align:left; padding:11px 12px; color:#fff; font-size:12px; font-weight:700; border:none;">Description</th>
        <th style="text-align:left; padding:11px 8px; color:#fff; font-size:12px; font-weight:700; border:none;">HSN</th>
        <th style="text-align:center; padding:11px 8px; color:#fff; font-size:12px; font-weight:700; border:none;">Qty</th>
        <th style="text-align:right; padding:11px 8px; color:#fff; font-size:12px; font-weight:700; border:none;">Rate</th>
        <th style="text-align:right; padding:11px 12px; color:#fff; font-size:12px; font-weight:700; border:none;">Amount</th>
        ${anycgst ? `
          <th style="text-align:right; padding:11px 8px; color:#fff; font-size:11px; font-weight:700; border:none;">CGST%</th>
          <th style="text-align:right; padding:11px 8px; color:#fff; font-size:11px; font-weight:700; border:none;">CGST ₹</th>
          <th style="text-align:right; padding:11px 8px; color:#fff; font-size:11px; font-weight:700; border:none;">SGST%</th>
          <th style="text-align:right; padding:11px 8px; color:#fff; font-size:11px; font-weight:700; border:none;">SGST ₹</th>
        ` : `
          <th style="text-align:right; padding:11px 8px; color:#fff; font-size:11px; font-weight:700; border:none;">IGST%</th>
          <th style="text-align:right; padding:11px 8px; color:#fff; font-size:11px; font-weight:700; border:none;">IGST ₹</th>
        `}
      </tr>
    </thead>
    <tbody>
      ${final.map((item, i) => `
        <tr style="background:${i % 2 === 0 ? '#fff' : '#f8fafc'};">
          <td style="text-align:left; padding:10px 12px; border-bottom:1px solid #f1f5f9; font-weight:600;">${item.name}</td>
          <td style="text-align:left; padding:10px 8px; border-bottom:1px solid #f1f5f9; color:#64748b; font-size:11px;">${item?.hsn || '—'}</td>
          <td style="text-align:center; padding:10px 8px; border-bottom:1px solid #f1f5f9;">${item.qty}</td>
          <td style="text-align:right; padding:10px 8px; border-bottom:1px solid #f1f5f9;">₹ ${item.totalbeforetax}</td>
          <td style="text-align:right; padding:10px 12px; border-bottom:1px solid #f1f5f9; font-weight:700;">₹ ${item.total}</td>
          ${item.cgst && item.sgst ? `
            <td style="text-align:right; padding:10px 8px; border-bottom:1px solid #f1f5f9; color:#7c3aed;">${item.cgst}%</td>
            <td style="text-align:right; padding:10px 8px; border-bottom:1px solid #f1f5f9; color:#7c3aed;">₹ ${item.cgsttotal}</td>
            <td style="text-align:right; padding:10px 8px; border-bottom:1px solid #f1f5f9; color:#7c3aed;">${item.sgst}%</td>
            <td style="text-align:right; padding:10px 8px; border-bottom:1px solid #f1f5f9; color:#7c3aed;">₹ ${item.sgsttotal}</td>
          ` : `
            <td style="text-align:right; padding:10px 8px; border-bottom:1px solid #f1f5f9; color:#7c3aed;">${item.igst || '—'}</td>
            <td style="text-align:right; padding:10px 8px; border-bottom:1px solid #f1f5f9; color:#7c3aed;">₹ ${item.igsttotal}</td>
          `}
        </tr>
      `).join("")}
    </tbody>
  </table>
<!-- Two Side-by-Side Summary Tables -->
<div style="
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  margin-top: 20px;
  flex-wrap: wrap;
  max-width: 100%;
">
  <!-- Bill Summary -->
  <table style="
    flex: 1;
    min-width: 320px;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 12px 16px;
    background-color: #fcfcfc;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
    font-size: 14px;
    line-height: 1.6;
  ">
    <thead>
      <tr>
        <th colspan="2" style="text-align: left; font-size: 15px; padding-bottom: 8px; color: #333;">
          🧾 Bill Summary
        </th>
      </tr>
    </thead>
    <tbody>
      <tr><td>Total Before Tax</td><td style="text-align:right;">₹ ${totalbeforetax}</td></tr>
      <!-- <tr><td>Total (incl. Taxes)</td><td style="text-align:right;">₹ ${ctotal}</td></tr> -->
      ${cdiscount > 0 ? `<tr><td>Discount</td><td style="text-align:right;">-₹ ${cdiscount}</td></tr>` : ''}
      <tr><td><strong>Total Payable (incl. Taxes)</strong></td><td style="text-align:right;"><strong>₹ ${(ctotal - cdiscount)}</strong></td></tr>
      <tr>
        <td>Payment Mode</td>
        <td style="text-align:right;">
          ${
            (() => {
              const payments = (newBill?.payments || []).filter(p => Number(p.amount) > 0);

              if (payments.length === 0) return "None";

              return payments
                .map(p => `${p.mode} (₹ ${Number(p.amount).toFixed(2)})`)
                .join(" | ");
            })()
          }
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Payment Details -->
  <!--
  <table style="
    flex: 1;
    min-width: 320px;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 12px 16px;
    background-color: #fcfcfc;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
    font-size: 14px;
    line-height: 1.6;
  ">
    <thead>
      <tr>
        <th colspan="2" style="text-align: left; font-size: 15px; padding-bottom: 8px; color: #333;">
          💰 Payment Details
        </th>
      </tr>
    </thead>
    <tbody>
      ${Number(company.paidToPrevious || 0) > 0 ? `
        <tr>
          <td>Paid to Previous Dues</td>
          <td style="text-align:right;">₹ ${Number(company.paidToPrevious)}</td>
        </tr>` : ''}
      ${Number(company.paidToCurrent || 0) > 0 ? `
        <tr>
          <td>Paid to Current Bill</td>
          <td style="text-align:right;">₹ ${Number(company.paidToCurrent)}</td>
        </tr>` : ''}
      ${Number(company.givenback || 0) > 0 ? `
        <tr>
          <td>Given Back to Client</td>
          <td style="text-align:right; color:#d9534f;">₹ ${Number(company.givenback)}</td>
        </tr>` : ''}
      <tr>
        <td><strong>Total Received (This Visit)</strong></td>
        <td style="text-align:right;"><strong>₹ ${Number(company.paidToPrevious || 0) + Number(company.paidToCurrent || 0)}</strong></td>
      </tr>
      <tr>
        <td><strong>Outstanding Balance</strong></td>
        <td style="text-align:right;"><strong>₹ ${Number(company.balance || 0)}</strong></td>
      </tr>
  
    </tbody>
  </table>
  -->
</div>

<!-- Final Summary -->
${(() => {
  //const prevDue = Number(company.previousOutstanding || 0);
  const prevDue =
    parseFloat(getpreviousOutstanding(company?.orgDetails?.name, billIndex)) || 0;

  const currentDue = Number(ctotal - cdiscount || 0);
  const paidPrev = Number(company.paidToPrevious || 0);
  const paidCurr = Number(company.paidToCurrent || 0);
  const paid = paidPrev + paidCurr;
  const givenback = Number(company.givenback || 0);
  const finalBalance = Number(company.balance || 0);
  const isFirstBill = (billIndex == 0);

  // Derived net outstanding across all bills (clinic-wide)
  const netOutstanding =
    Number(billDetails?.total) +
    getTotalPreviousOutstanding() -
    Number(receivedAmount) +
    Number(givenBackAmount);

      // Determine label based on service type and balance
    let label = '';
    if (isRefundService(company.services[0].name)) {
      label = netOutstanding > 0 ? 'Refund' : 'Pending';
    } else if (isPendingService(company.services[0].name)) {
      label = netOutstanding > 0 ? 'Pending' : 'Credit';
    } else {
      label = netOutstanding > 0 ? 'Pending' : netOutstanding < 0 ? 'Credit' : 'Cleared';
    }

    // Determine color based on label
    let color = '';
    switch (label) {
      case 'Pending':
        color = 'red';
        break;
      case 'Credit':
        color = 'green';
        break;
      case 'Refund':
        color = 'purple';
        break;
      default:
        color = 'gray';
    }

  
  if (prevDue > 0 || currentDue > 0 || paid > 0 || givenback > 0) {
    return `
      <hr style="border: none; border-top: 2px solid #999; margin: 15px 0;">
      <h4 style="margin-bottom: 8px;">🧾 Final Summary</h4>
      <table style="width: 100%; border-collapse: collapse; font-size: 13px;">
        <tr>
          <td style="padding: 6px; border: 1px solid #ddd;">Previous Outstanding</td>
          <td style="padding: 6px; text-align: right; border: 1px solid #ddd;">₹ ${prevDue}</td>
        </tr>
        <tr>
          <td style="padding: 6px; border: 1px solid #ddd;">Current Bill Amount</td>
          <td style="padding: 6px; text-align: right; border: 1px solid #ddd;">₹ ${currentDue}</td>
        </tr>
        <tr>
          <td style="padding: 6px; border: 1px solid #ddd;">Total Due</td>
          <td style="padding: 6px; text-align: right; border: 1px solid #ddd; font-weight: bold;">₹ ${(prevDue + currentDue)}</td>
        </tr>
        <tr>
          <td style="padding: 6px; border: 1px solid #ddd;">Total Received</td>
          <td style="padding: 6px; text-align: right; border: 1px solid #ddd;">₹ ${paid}</td>
        </tr>
   
        ${paidPrev > 0 ? `
        <tr>
          <td style="padding: 6px; border: 1px solid #ddd;">Paid Towards Previous Balance</td>
          <td style="padding: 6px; text-align: right; border: 1px solid #ddd;">₹ ${paidPrev}</td>
        </tr>` : ''}
        ${paidCurr > 0 ? `
        <tr>
          <td style="padding: 6px; border: 1px solid #ddd;">Paid Towards Current Bill</td>
          <td style="padding: 6px; text-align: right; border: 1px solid #ddd;">₹ ${paidCurr}</td>
        </tr>` : ''}
        ${givenback > 0 ? `
        <tr>
          <td style="padding: 6px; border: 1px solid #ddd;">Given Back to Client</td>
          <td style="padding: 6px; text-align: right; border: 1px solid #ddd; color: #d9534f;">₹ ${givenback}</td>
        </tr>` : ""}
        <tr>
          <td style="padding: 6px; border: 1px solid #ddd; font-weight: bold;">Final Outstanding Balance</td>
          <td style="padding: 6px; text-align: right; border: 1px solid #ddd; font-weight: bold;">₹ ${finalBalance}</td>
        </tr>
        ${isFirstBill && netOutstanding !== 0 ? `
      <tr>
  <td style="padding: 6px; border: 1px solid #ddd; font-weight: bold;">
    Net Outstanding (Clinic Total)
  </td>
  <td style="
      padding: 6px; 
      text-align: right; 
      border: 1px solid #ddd; 
      font-weight: bold;
      color: ${color};
    ">
    ₹ ${Number(netOutstanding).toFixed(2)} (${label})
  </td>
</tr>
` : ""}
        <tr>
          <td colspan="2" style="padding-top:12px; font-size:11px; color:#94a3b8; line-height:1.6; border-top:1px solid #e2e8f0;">
            ${footNote.replace(/\n/g,'<br>')}
          </td>
        </tr>
      </table>
    `;
  }
  return "";
})()}

  </div><!-- /padding wrapper -->
  </div><!-- /receipt -->
`;


}

// --- Helper function to generate WhatsApp Text ---
function generateBillText(company, billIndex) {
  
   var todayDate = new Date();
  console.log("full company = ", company );
  var ctotal = parseInt(company.total, 10) || 0;
  var cpaid = parseInt(company.paid, 10) || 0;
  var cdiscount = parseInt(company.discount, 10) || 0;
  var ctotalbeforetax = parseInt(company.totalbeforetax, 10) || 0;

var companyNameMap = {
  "MedicalyogaTherapyCentre": "Medical Yoga Therapy Centre",
  "MedicalyogaAssociation": "Medical Yoga Association",
  "ReRoot": "Re root",
  "GoodLifeAcademy": "Good Life Academy"
}
var cname = companyNameMap[company.orgDetails.name]; 

    let total = 0;
    let totalbeforetax = 0;
    let anyigst = false;
    let anydiscount = false;
    let anycgst = false;
    let anyecess = false;

    let final = company.services.map(s => {

      let cgsttotal = 0;
      let sgsttotal = 0;  
      let igsttotal = 0;
      let ecesstotal = 0;
  
      const qty = s.qty || 1;
      //subtotal += qty * s.amount;
      totalbeforetax += qty * s.amount;
      
      if (s.sgst && s.cgst && s.sgst > 0  && s.cgst > 0) {
          cgsttotal = totalbeforetax * (s.cgst) / 100;
          sgsttotal = totalbeforetax * (s.sgst) / 100;

          total = totalbeforetax + (sgsttotal + cgsttotal);
          anycgst = true;
      }
      else if (s.igst) 
      {
          igsttotal = totalbeforetax * (s.igst) / 100;
          total = totalbeforetax + igsttotal;
          anyigst = true;
      }
      if (s.ecess) 
      {
          ecesstotal = totalbeforetax * s.ecess / 100 
          total += ecesstotal;
          anyecess = true;
      }
      if (s.sdiscount && s.sdiscount > 0) {
          total -= s.sdiscount;
          anydiscount = true;
      }
      console.log("bill row = ", s );  
      if (anycgst == false && anyigst == false)
        anycgst = true;
      return {
        ...s,
        cgsttotal: cgsttotal,
        sgsttotal: sgsttotal,
        igsttotal: igsttotal,
        ecesstotal: ecesstotal,
        totalbeforetax: totalbeforetax,
        total: total,
      }
   
  });
 
  let text = `\n*${cname}*\n`;
  if ( company.orgDetails.gstin )
     text +=  `GSTIN: ${company.orgDetails.gstin}\n`;
  if ( company.orgDetails.address )
    text += `${company.orgDetails.address}\n\n`;
  text += `Invoice No: ${company.invoicenumber}\n`;
  text += `Invoice Date: ${new Date().toLocaleDateString()}\n`;
  text += `Name: ${company.name} / ${company.number}\n`;
  text += `Cashier: ${company.cashier}\n`;
  text += `*Services:*\n`;
  company.services.forEach((item, idx) => {
    text += `${idx + 1}. ${item.name} (Qty: ${item.qty}) - ₹ ${item.amount}\n`;
    if (anycgst) {
        text += `   CGST:${item.cgst}% \n`; 
        text += `   SGST:${item.sgst}% \n`; 
        
    } else if (anyigst) {
        text += `   IGST:${item.igst}% \n`; 
    }   
    //text += `ECESS:${s.ecess}% \n`; 
  });

  text += `\n*Summary:*\n`;
  var pm = company.paymentmode
  if (company.paid == 0)
  {
     pm = "-";
  }
  text += `Total Before Tax: ₹ ${totalbeforetax}`;
  //text += `Total (incl. taxes): ₹ ${ctotal}\n`;
  if (cdiscount)
    text += `Discount: ₹ ${cdiscount}\n`;

  text += `Total Payable(incl. Taxes): ₹ ${ctotal - cdiscount}\n`;
  const validPayments = (newBill?.payments || []).filter(
    p => Number(p.amount) > 0
  );

  const paymentSummary =
    validPayments.length > 0
      ? validPayments.map(p => `${p.mode}: ₹${Number(p.amount).toFixed(2)}`).join(" | ")
      : "None";

  text += `Payment Mode: ${paymentSummary}\n`;

  //text += `Paid: ₹ ${cpaid}\nBalance: ₹ ${company.balance}\nPayment Mode: ${pm}`;

  //const prevDue = Number(company.previousOutstanding || 0);
  const prevDue =
    parseFloat(getpreviousOutstanding(company?.orgDetails?.name, billIndex)) || 0;

  const currentDue = Number(ctotal - cdiscount || 0);
  const paidPrev = Number(company.paidToPrevious || 0);
  const paidCurr = Number(company.paidToCurrent || 0);
  const paid = paidPrev + paidCurr;
  const givenback = Number(company.givenback || 0);
  const finalBalance = Number(company.balance || 0);
  const isFirstBill = (billIndex == 0);

  // Derived net outstanding across all bills (clinic-wide)
  const netOutstanding =
    Number(billDetails?.total) +
    getTotalPreviousOutstanding() -
    Number(receivedAmount) +
    Number(givenBackAmount);

  
  if (prevDue > 0 || currentDue > 0 || paid > 0 || givenback > 0) {
    text += `\n*Final Summary:*\n`;
    text += `Previous Outstanding: ₹ ${prevDue}\n`;
    text += `Current Bill Amount: ₹ ${currentDue}\n`;
    text += `Total Due: ₹ ${prevDue + currentDue}\n`;
    text += `*Received:* ₹ ${paid}\n`;

    if (paidPrev > 0)
      text += `Paid Towards Previous Balance: ₹ ${paidPrev}\n`;

    if (paidCurr > 0)
      text += `Paid Towards Current Bill: ₹ ${paidCurr}\n`;

    if (givenback > 0)
      text += `Given Back to Client: ₹ ${givenback}\n`;

    text += `Final Outstanding Balance: ₹ ${finalBalance}\n`;

    if (isFirstBill && netOutstanding !== 0) {
      text += `Net Outstanding (Clinic Total): ₹ ${netOutstanding.toFixed(2)} ${netOutstanding < 0 ? '(Credit to client)' : '(Pending)'}\n`;
    }    
  }
    text += "\n\n";
  return text;
}

// --- Main handler to Print ---
function handlePrint(companies, printWindow) {
  if (!companies || companies.length <= 0) {
    if (printWindow) printWindow.close();
    return;
  }
  if (!printWindow) {
    showToast('Print window was blocked. Please allow popups and try again.', 'error');
    return;
  }

   const style = `
    <style>
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800;900&display=swap');
      * { box-sizing: border-box; }
      body {
        font-family: 'Inter', 'Segoe UI', system-ui, sans-serif;
        margin: 0; padding: 24px;
        background: #f1f5f9;
        font-size: 13px; color: #1e293b;
      }
      .receipt {
        background: #fff;
        border-radius: 16px;
        overflow: hidden;
        margin-bottom: 32px;
        box-shadow: 0 4px 24px rgba(0,0,0,0.10);
        border: 1px solid #e2e8f0;
        page-break-after: always;
        break-after: page;
      }
      table { width: 100%; border-collapse: collapse; }
      th, td { padding: 10px 12px; text-align: right; }
      th { font-size: 12px; font-weight: 700; letter-spacing: 0.4px; }
      td { font-size: 13px; }
      @media print {
        body { margin: 0; padding: 8px; background: #fff; }
        .receipt { box-shadow: none; border: 1px solid #ccc; margin-bottom: 0; border-radius: 8px; }
        .page-break { page-break-after: always; break-after: page; }
      }
    </style>
  `;

  printWindow.document.write(`<html><head>${style}</head><body>`);

  companies.forEach((company, index) => {
    console.log("Print Bill for company 111 ==> ", company, company.services);
    printWindow.document.write(generateBillHTML(company, index));
  });

  printWindow.document.write('</body></html>');
  printWindow.document.close();

  setTimeout(() => {
    printWindow.print();
    onClose();
    navigate('/ListPatients');
  }, 500);
}

// --- Main handler to Send on WhatsApp ---
const handleSendWhatsApp = async(e) => {

  if (await checkRecvdLogic() === false)
  {
    return;
  }

  const companies = await generateCompaniesWithBillDetails(e, false);
  if (!companies || companies.length <= 0)
    return;

  var encodedText = "";
  var phone = 0;
  companies.map((company, idx) => {
    console.log("Print Bill for company TEXT 222 ==> ", company);
    encodedText += encodeURIComponent(generateBillText(company, idx));
    phone = String(company.number).replace(/\D/g, "");
  });
  
  encodedText += encodeURIComponent(footNote);
  const whatsappUrl = `https://wa.me/91${phone}?text=${encodedText}`;
  //var whatsappURL = `https://wa.me/${company.phone}?text=${encodedText}`;
  
  window.open(whatsappUrl, '_blank');  
  onClose();
  navigate('/ListPatients');
}

const handleDiscountChange = (billIndex, serviceIndex, value) => {
  const updatedBills = [...bills];
  const bill = updatedBills[billIndex];
  const service = bill?.bills?.[serviceIndex];

  if (!service) return;

  service.sdiscount = parseFloat(value || 0);

  // Optionally update bill.discount immediately:
  bill.discount = (bill.bills || []).reduce(
    (sum, item) => sum + parseFloat(item.sdiscount || 0),
    0
  );

  // Update balance
  const total = parseFloat(bill.totalbeforediscount || 0);
  const paid = parseFloat(bill.paid || 0);
  const givenback = parseFloat(bill.givenback || 0);

  bill.balance = total - bill.discount - paid + givenback;

  // Update status
  bill.status =
    bill.balance === 0
      ? "paid"
      : bill.balance === total
      ? "pending"
      : "partial";

  updatedBills[billIndex] = { ...bill };
  setBills(updatedBills);
  updateBillFinalDetails(updatedBills);
};

// ✅ Manual Allocation Editor for Floating Summary
// ✅ Manual Allocation Editor for Floating Summary
function handleAllocationChange(billIndex, field, value) {
  const updatedBills = [...bills];
  const updatedSummary = [...allocationSummary];
  const bill = { ...updatedBills[billIndex] };
  const entry = { ...updatedSummary[billIndex] };

  const numericValue = parseFloat(value || 0);

  if (field === "paidToCurrent") {
    entry.paidToCurrent = numericValue;
    bill.paidToCurrent = numericValue;
    bill.isManualEdit = true; // mark as manually changed
  }

  // Keep paidToPrevious constant
  entry.paidToPrevious = bill.paidToPrevious || 0;

  // Recompute total paid and status
  const totalPaid = entry.paidToPrevious + entry.paidToCurrent;
  bill.paid = totalPaid;

  const previousDue =
    parseFloat(getpreviousOutstanding(bill?.orgDetails?.name, billIndex)) || 0;
  const totalBeforeDiscount = parseFloat(bill.totalbeforediscount || 0);
  const discount = (bill?.bills || []).reduce(
    (sum, s) => sum + parseFloat(s.sdiscount || 0),
    0
  );

  const currentDue = totalBeforeDiscount - discount;
  const totalDue = previousDue + currentDue;
  bill.balance = totalDue - totalPaid;

  bill.status =
    bill.balance <= 0
      ? "paid"
      : totalPaid === 0
      ? "pending"
      : "partial";

  updatedBills[billIndex] = bill;
  updatedSummary[billIndex] = entry;

  // Save both
  setBills(updatedBills);
  setAllocationSummary(updatedSummary);

  // Keep global receivedAmount same
  updateBillFinalDetails(updatedBills);
}


const allocateReceivedAmount = (amountReceived, givenbackGlobal = 0) => {
  setReceivedAmount(amountReceived); 
  setrecvdAmountInWords(numberToWords(parseInt(amountReceived, 10)));

  let remaining = parseFloat(amountReceived || 0) - parseFloat(givenbackGlobal || 0);

  const updatedBills = [...bills];
  const summary = [];

  // 1. Pay all previous dues first across all bills
  for (let idx = 0; idx < updatedBills.length; idx++) {
    const bill = updatedBills[idx];

    if (bill.isManualEdit) {
      summary.push({
        billIndex: idx,
        paid: bill.paid || 0,
        paidToPrevious: bill.paidToPrevious || 0,
        paidToCurrent: bill.paidToCurrent || 0,
        manual: true,
      });
      continue;
    }

    const previousDue = parseFloat(getpreviousOutstanding(bill?.orgDetails?.name, idx)) || 0;
    const toPrevious = Math.min(remaining, previousDue);
    remaining -= toPrevious;

    updatedBills[idx] = {
      ...bill,
      paidToPrevious: toPrevious,
      // We will calculate 'paid' and 'balance' later after current dues allocation
    };
  }

  // 2. Then allocate remaining to current dues
  for (let idx = 0; idx < updatedBills.length; idx++) {
    const bill = updatedBills[idx];

    if (bill.isManualEdit) {
      continue;
    }

    const total = parseFloat(bill.totalbeforediscount || 0);
    const discount = (bill?.bills || []).reduce(
      (sum, s) => sum + parseFloat(s.sdiscount || 0),
      0
    );
    const currentDue = total - discount;
    const previousPaid = updatedBills[idx].paidToPrevious || 0;

    const toCurrent = Math.min(remaining, currentDue);
    remaining -= toCurrent;

    const paid = previousPaid + toCurrent;
    const balance = (previousPaid + currentDue) - paid; // previousDue + currentDue - paid

    updatedBills[idx] = {
      ...updatedBills[idx],
      paid,
      discount,
      balance,
      paidToCurrent: toCurrent,
      status:
        paid === previousPaid + currentDue
          ? "paid"
          : paid === 0
          ? "pending"
          : "partial",
    };

    summary.push({
      billIndex: idx,
      paid,
      paidToPrevious: previousPaid,
      paidToCurrent: toCurrent,
    });
  }

  setBills(updatedBills);
  setAllocationSummary(summary);
  updateBillFinalDetails(updatedBills);
};

// ✅ Manual Input per Bill – marks bill as manually edited and resyncs totals safely

function setTextValue(value, idx, key) {
  const updatedBills = [...bills];
  const currentBill = { ...updatedBills[idx] };

  const savedPaymentMode = currentBill.paymentmode;

  currentBill[key] = parseFloat(value || 0);
  currentBill.isManualEdit = true; // 🧩 mark as user-edited

  const billDiscount = (currentBill?.bills || []).reduce(
    (sum, service) => sum + parseFloat(service.sdiscount || 0),
    0
  );
  currentBill.discount = billDiscount;

  currentBill.balance =
    Number(currentBill.total || 0) -
    Number(currentBill.discount || 0) -
    Number(currentBill.paid || 0);

  currentBill.paymentmode = savedPaymentMode;

  currentBill.status =
    currentBill.balance <= 0
      ? "paid"
      : currentBill.paid === 0
      ? "pending"
      : "partial";

  updatedBills[idx] = currentBill;
  setBills(updatedBills);

  // 🔁 Sync totals
  updateBillFinalDetails(updatedBills);

  // 🔁 Allocation summary based on manual + auto bills
  const newSummary = updatedBills.map((b, i) => ({
    billIndex: i,
    paid: parseFloat(b.paid || 0),
    manual: !!b.isManualEdit,
  }));
  setAllocationSummary(newSummary);

  // 🔁 Global received = sum of all per-bill paid values
  const totalReceived = newSummary.reduce((sum, b) => sum + b.paid, 0);
  setReceivedAmount(totalReceived);
}

const updateBillFinalDetails = (updatedBills) => {
  // Don't overwrite existing totals if the bills array is empty (race on mount or empty pBills)
  if (!updatedBills || updatedBills.length === 0) return;

  let totalBeforeDiscount = 0;
  let totalDiscount = 0;
  let totalPaid = 0;
  let totalGivenback = 0;
  let hasSpecial = billDetails?.hasSpecial ?? false;

  updatedBills.forEach((bill) => {
    totalBeforeDiscount += parseFloat(bill.totalbeforediscount || 0);
    totalPaid += parseFloat(bill.paid || 0);
    totalGivenback += parseFloat(bill.givenback || 0);

    const serviceDiscount = (bill?.bills || []).reduce(
      (sum, service) => sum + parseFloat(service.sdiscount || 0),
      0
    );
    totalDiscount += serviceDiscount;
  });

  const total = (totalBeforeDiscount - totalDiscount)?.toFixed(2);
  const balance = (total - totalPaid + totalGivenback)?.toFixed(2);

  console.log("Summary:", {
    totalBeforeDiscount,
    totalDiscount,
    totalPaid,
    totalGivenback,
    balance,
    total,
  });

  
  setBillDetails({
    totalbeforediscount: totalBeforeDiscount.toFixed(2),
    discount: totalDiscount.toFixed(2),
    total: total,
    paid: totalPaid.toFixed(2),
    balance: balance,
    givenback: totalGivenback.toFixed(2),
    hasSpecial: hasSpecial,
  });
  
};

const getTotalPreviousOutstanding = () => {
  console.log(" bill has special service ?? ", billDetails);
  if (billDetails.hasSpecial == true)
  {
    return 0;
  }

  var totalprevDue = 0;
  var b = bills;
  for (var i=0; i< b.length; i++) 
  {
    console.log ("print bill i =", i, b[i])
    totalprevDue += getpreviousOutstanding( b[i].orgDetails.name); 
  }
  console.log("==========", totalprevDue, Number(selectedPatient?.totalSoFar) - Number(selectedPatient?.totalPaidSoFar) );
  
  return Number(totalprevDue.toFixed(2));
}


const getpreviousOutstanding = (org, billIndex) => {
  console.log(" bill has special service ?? ", billDetails);
  if (billDetails.hasSpecial == true)
  {
     
    return 0;
  }

  var dets = selectedPatient?.previousbalancedetails || [];
  for (var i=0; i< dets.length; i++)
  {
    console.log(" balance dets ", dets[i]["org"]);
    if (dets[i]["org"] == org)
    {
       return Number((Number(dets[i]?.balance || 0)).toFixed(2));
    }
  }
  console.log("==========");
  return 0;
}

const updateNetOutstanding = (total, receivedAmount, givenBackAmount) =>
{
  var final = total - receivedAmount + givenBackAmount;
  final += Number(getTotalPreviousOutstanding());
  return final; // put it in Therapy Bill
}

const checkRecvdLogic = async () => {
  var torecv = Number(billDetails?.total) + getTotalPreviousOutstanding();
  const msg = `₹${torecv} — क्या आप शेष बकाया ₹${netOutstandingBalance} के साथ बिलिंग करना चाहते हैं?`;

  if (netOutstandingBalance != 0) {
    const confirmed = await showConfirm(msg);
    if (confirmed) return true;
    showToast("Billing cancelled", 'info');
    return false;
  }
  return true;
}

const printBill = async(e) => {

  if (await checkRecvdLogic() === false)
  {
    return;
  }

  // Open print window BEFORE async work — browsers block window.open() after await
  const printWindow = window.open('', '', 'height=600,width=800');
  if (!printWindow) {
    showToast('Popup blocked — please allow popups for this site and try again.', 'error');
    return;
  }
  printWindow.document.write('<html><body><p style="font-family:sans-serif;padding:40px">Generating bill… please wait.</p></body></html>');

  const companies = await generateCompaniesWithBillDetails(e, true);
  handlePrint(companies, printWindow);

}

const generateCompaniesWithBillDetails = async(e, toSave) => {
  var allBills = [];
  var b = bills; // data.bills
  for (var i=0; i< b.length; i++) {
    console.log ("print bill i =", i, b[i])
    var saveBill = {}
    saveBill.branch = b[i].branch;
    saveBill.billorg = b[i].orgDetails.name;
    saveBill.patientCard = selectedPatient.patientCard;
    saveBill.name = selectedPatient.name;
    saveBill.number = selectedPatient.number;
    saveBill.patientBranch = selectedPatient.branch;
    saveBill.invoicenumber = b[i].invoicenumber;
    saveBill.invoicedate = b[i].invoicedate; //new Date();
    saveBill.totalbeforediscount = b[i].totalbeforediscount;
    saveBill.discount = b[i].discount;
    saveBill.total = b[i].total;
    saveBill.paid = b[i].paid;
    saveBill.givenback = b[i].givenback || 0;
    saveBill.paidToCurrent = b[i].paidToCurrent || 0;
    saveBill.paidToPrevious = b[i].paidToPrevious || 0;
    saveBill.prevDue =  parseFloat(getpreviousOutstanding(b[i].orgDetails?.name, i)) || 0;
 
    const currentDue = Number(saveBill.total || 0) - Number(saveBill.discount || 0);
    const previousDue = Number(saveBill.prevDue || 0) - Number(saveBill.paidToPrevious || 0);
    const paidNow = Number(saveBill.paidToCurrent || 0);
    const refundGiven = Number(saveBill.givenback || 0);

    const balance =
      currentDue +
      previousDue -
      paidNow +
      refundGiven;

    saveBill.balance = balance.toFixed(2);

    saveBill.txnid = b[i].paymentmode; //b[i].txnid;

    saveBill.paymentmode = b[i].paymentmode;
    saveBill.status = b[i].status;
    saveBill.services = b[i].bills;
    saveBill.comments = b[i].comments;
    saveBill.raw = b[i].raw;
    saveBill.cashier = auth.username;
    console.log ("print bill i ====== ", saveBill)
    
    if (saveBill.txnid == undefined || saveBill.txnid?.trim() === "") {
      e.preventDefault();
      showToast("Please add a transaction ID for the bill.", 'warning');
      return;
    }
    if (parseFloat(saveBill.paid) === 0 && ( saveBill.txnid == undefined || saveBill?.comments?.trim() === "")) {
      e.preventDefault();
      showToast("Please add a comment explaining why payment is ₹0.", 'warning');
      return;
    }
    
    if (parseFloat(saveBill.balance) !== 0 && ( saveBill.txnid == undefined || saveBill?.comments?.trim() === "")) {
      e.preventDefault();
      showToast("Please add a comment explaining why payment is incomplete.", 'warning');
      return;
    }
  
  
    var nn = saveBill;
    nn["orgDetails"] = b[i].orgDetails;
    allBills.push(nn);

    console.log("balance and outstanding of Therapy = ", allBills[0].balance , netOutstandingBalance);
      if (netOutstandingBalance < 0) // credit - add to 1st bill
      {
          const numBalance = Number(netOutstandingBalance) || 0;
          allBills[0].balance = numBalance;
          allBills[0].paid += (-1 * numBalance);
      } // else it will be part of balance 

      
    if (toSave) {

      console.log("-- patientCData ", patientCData);
      console.log("-- therapist", patientCData?.therapist);
      try {
      var response = await api.post(
        `${process.env.REACT_APP_URL}/bills/add/${selectedPatient.patientCard}`, saveBill);

        if (response && response.status == 200) {
          console.log("-- billed", {...patientCData, ...saveBill});
            // update data for qty change, startdate & therapist 
            // send bills ( actual services with new qty ) + suggested services (with old qty) 
            // + start date, name, number, branch, 
           
             api.post(
              `${process.env.REACT_APP_URL}/patients/postconsultation/${selectedPatient.patientCard}`, 
                {...patientCData, ...saveBill})
              
              .then(resp => {
                  console.log("-- data updated");
                  // update data for qty change, startdate & therapist 
                  
              })    
              .catch(err => {
                  console.error("❌ Error updating patient postconsultation:", err);
                  if (patientCData == undefined || patientCData.therapist == undefined || patientCData.timePref == undefined)
                    {
                      // must be direct billing case without postconsultation.
                      // no need to try to generate appointments.
                      showToast(String(err?.message || err), 'error');
                    }
                });    
        }
        else { 
          showToast('Error saving bill. Please generate bills again.', 'error');
        } 
      }
       catch (error) {
          console.error("Error saving Bill:", error);
          const message =
            error.response?.data?.error || 'Error saving Bill. Please generate bills again';
          showToast(message, 'error');
        }
    }
  }
  return allBills;
}

return (
  <>
    {/* Overlay */}
    <div
      className={`billing-drawer-overlay open`}
      onClick={() => onClose && onClose()}
    />

    {/* Drawer */}
    <aside
      className={`billing-drawer open`}
      role="dialog"
      aria-label="Billing Summary Drawer"
    >
      <header className="drawer-header">
        <div className="drawer-title">
          <h3>Billing Summary</h3>
          <small className="drawer-sub">Invoice & allocation</small>
        </div>

        <div className="drawer-actions">

        </div>
      </header>

      <div className="drawer-body">

        {/* Top summary card — 2×2 grid */}
        <section className="card summary-card">
          <div className="summary-grid">
            <div className="summary-box">
              <div className="summary-box-label">Discount</div>
              <div className="summary-box-value">₹ {billDetails?.discount ?? 0}</div>
            </div>
            <div className="summary-box">
              <div className="summary-box-label">Today's (incl. Tax)</div>
              <div className="summary-box-value">₹ {Number(billDetails?.total ?? 0).toFixed(2)}</div>
            </div>
            {!billDetails.hasSpecial && (
            <div className="summary-box">
              <div className="summary-box-label">Previous Balance</div>
              <div className="summary-box-value" style={{ color: getTotalPreviousOutstanding() > 0 ? '#dc2626' : '#16a34a' }}>₹ {getTotalPreviousOutstanding()}</div>
            </div>
            )}
            <div className="summary-box summary-box-total">
              <div className="summary-box-label">Total To Pay</div>
              <div className="summary-box-value">
                <strong>₹ {(Number(billDetails?.total || 0) + getTotalPreviousOutstanding()).toFixed(2)}</strong>
              </div>
            </div>
          </div>
        </section>

        {/* ---------------- Payments + Quick Received Section ---------------- */}
        <section className="card payments-card">
          <div className="section-title">💵 Payments

           <button
              className="btn-add"
              onClick={() => {
                const usedModes = payments.map((p) => p.mode);
                const nextMode = ["Cash", "UPI", "Card"].find((m) => !usedModes.includes(m));
                if (!nextMode) return;

                const updated = [...payments, { mode: nextMode, amount: 0 }]; // include new mode
                setPayments(updated);

                setNewBill({
                  ...newBill,
                  payments: updated.map(p => ({ ...p }))
                });
              }}
            >
              ➕ Add Mode
            </button>


          </div>

          {payments.map((pmt, idx) => {
            const usedModes = payments.map((p) => p.mode);
            const availableModes = ["Cash", "UPI", "Card"].filter(
              (mode) => mode === pmt.mode || !usedModes.includes(mode)
            );

            return (
              <React.Fragment key={idx}>
                <div className="payment-row">
                  {/* Remove button */}
                  <button
                    className="btn-remove"
                    onClick={() => {
                      const updated = [...payments];
                      updated.splice(idx, 1);
                      setPayments(updated);

                      // Sync with bill
                      setNewBill({
                        ...newBill,
                        payments: updated.map(p => ({ ...p }))
                      });

                      const newTotal = updated.reduce((sum, p) => sum + Number(p.amount || 0), 0);
                      setReceivedAmount(newTotal);
                      allocateReceivedAmount(newTotal);
                    }}
                  >
                    ✕
                  </button>

                  {/* Mode selector */}
                  <select
                    value={pmt.mode}
                    onChange={(e) => {
                      const updated = [...payments];
                      updated[idx].mode = e.target.value;
                      setPayments(updated);

                      setNewBill({
                        ...newBill,
                        payments: updated.map(p => ({ ...p }))
                      });
                    }}
                  >
                    {availableModes.map((mode) => (
                      <option key={mode} value={mode}>
                        {mode}
                      </option>
                    ))}
                  </select>

                  {/* Amount input */}
                  <input
                    type="number"
                    min="0"
                    step="1"
                    value={pmt.amount}
                    onChange={(e) => {
                      updatePaymentAmount(idx, e.target.value);
                      setPayments([...payments]);

                      const updated = [...payments];
                      setNewBill({
                        ...newBill,
                        payments: updated.map(p => ({ ...p }))
                      });
                    }}
                    placeholder="0.00"
                  />

                  {/* UPI QR button inline */}
                  {pmt.mode === "UPI" && (
                    <button
                      type="button"
                      onClick={() => setShowUpiModal(true)}
                      style={{ padding: '4px 8px', background: '#f0fdf4', border: '1.5px solid #86efac', borderRadius: 6, cursor: 'pointer', fontWeight: 700, fontSize: 11, color: '#166534', whiteSpace: 'nowrap' }}
                    >
                      💳 QR
                    </button>
                  )}
                </div>

                {/* Amount in words — below the row, full width */}
                <div className="amount-words">
                  {pmt.amount > 0 ? numberToWords(Math.round(pmt.amount)) : ""}
                </div>
              </React.Fragment>
            );
          })}

          {/* Add Mode & Total Received */}
          <div className="payments-actions">
         
            {/*
            <div className="total-received">
              <div className="label">Total Received / Refunded</div>
              <div className="value">₹ {totalReceived.toFixed(2)}</div>
            </div>
            */}
          </div>

          {/* recvdAmountInWords && <div className="subtext"> {recvdAmountInWords}</div> */}

          {/* UPI QR button moved inline with UPI payment row */}
        </section>

        {/* ---------------- Quick Received (legacy) ---------------- */}
        <section className="card legacy-received">
          <div className="row">
            <div className="label">Amount Received / Refunded</div>
            <div className="value">
              <input
                type="number"
                min="0"
                step="1"
                value={receivedAmount}
                onChange={(e) => allocateReceivedAmount(Math.max(0, Number(e.target.value) || 0))}
                className="input-amount-compact"
                aria-label="Received amount quick input"
              />
            </div>
          </div>
          {recvdAmountInWords && <div className="subtext">{recvdAmountInWords}</div>}
        </section>

        {/* Allocation details */}
        <section className="card allocation-card">
          <div className="section-title">💰 Allocation</div>
          <div className="alloc-table-wrap">
            <table className="alloc-table" aria-label="Allocation summary">
              <thead>
                <tr>
                  <th style={{ textAlign: "left" }}>Bill</th>
                  <th style={{ textAlign: "right" }}>To Previous</th>
                  <th style={{ textAlign: "right" }}>To Current</th>
                </tr>
              </thead>
              <tbody>
                {allocationSummary.map((entry, idx) => {
                  const billOrg = bills[entry.billIndex]?.orgDetails?.name || '';
                  const orgAcronym = ({ ReRoot: 'RER', MedicalyogaTherapyCentre: 'MYC', MedicalyogaAssociation: 'MYA', GoodLifeAcademy: 'GLA' })[billOrg] || billOrg.slice(0, 3).toUpperCase();
                  return (
                  <tr key={idx}>
                    <td>{orgAcronym}</td>
                    <td style={{ textAlign: "right" }}>{Number(entry.paidToPrevious).toFixed(2)}</td>
                    <td style={{ textAlign: "right" }}>
                      <input
                        type="number"
                        value={Number(entry.paidToCurrent)?.toFixed(2)}
                        onChange={(e) => handleAllocationChange(idx, "paidToCurrent", e.target.value)}
                        className="input-alloc"
                      />
                    </td>
                  </tr>
                  );
                })}
                {(() => {
                  const totalPrev = allocationSummary.reduce((sum, e) => sum + e.paidToPrevious, 0);
                  const totalCurr = allocationSummary.reduce((sum, e) => sum + e.paidToCurrent, 0);
                  const totalAllocated = totalPrev + totalCurr;
                  const isMismatch =
                    Math.abs(totalAllocated - receivedAmount) > 0.01;
                  return (
                    <tr className={`totals-row ${isMismatch ? "mismatch" : ""}`}>
                      <td style={{ textAlign: "left" }}>Total</td>
                      <td style={{ textAlign: "right" }}>{Number(totalPrev).toFixed(2)}</td>
                      <td style={{ textAlign: "right" }}>
                        {Number(totalCurr).toFixed(2)}
                        {isMismatch && <span className="warn"> ⚠️</span>}
                      </td>
                    </tr>
                  );
                })()}
              </tbody>
            </table>
          </div>
        </section>

        {/* Given Back + Net */}
        <section className="card net-card">
          <div className="row">
            <div className="label">Change / Refund</div>
            <div className="value">
              <input
                type="number"
                min="0"
                step="1"
                value={givenBackAmount}
                onChange={(e) => {
                  const val = Math.max(0, Number(e.target.value) || 0);
                  setGivenBackAmount(val);
                  setgivenbackAmountInWords(numberToWords(val));
                }}
                className="input-amount-compact"
              />
            </div>
          </div>

          <div className="row highlight">
            <div className="label">Net Balance</div>
            <div className="value">
              <strong>
                {updateNetOutstanding(Number(billDetails?.total), Number(receivedAmount), Number(givenBackAmount))}
              </strong>
            </div>
          </div>

          {netAmountInWords && <div className="subtext">{netAmountInWords}</div>}
        </section>
      </div>

      <footer className="drawer-footer">
        <div className="footer-actions">
          <button className="btn whatsapp" onClick={handleSendWhatsApp}>💬 WhatsApp</button>
          <button className="btn print" onClick={printBill}>🧾 Save & Print</button>
        </div>
      </footer>
    </aside>

    {/* ---------- Remaining page content below (keeps your bills table & form) ---------- */}

    <div className="page-content">
      {/* ── Close Bill button ── */}
      {onClose && (
        <div style={{ marginBottom: 6 }}>
          <button
            className="btn btn-danger"
            onClick={onClose}
            style={{ padding: "4px 12px", fontSize: 12, borderRadius: 6, fontWeight: 700 }}
          >
            ✕ Close Bill
          </button>
        </div>
      )}

      {/* Bills Table Display (keeps your existing mapping & layout but wrapped) */}
      <div ref={conponentPDF} id="capture" style={{ width: "calc(100vw - 580px)", maxWidth: "55vw", marginBottom: "2vh" }}>
        {bills?.map((newBill, index) =>
          newBill?.bills?.length > 0 && (
            <div className="patient-main" key={index}>
              <div className="form-sections" style={{ minHeight: 'auto'}}>
                <h4 style={{ textAlign: "left" }}>{newBill?.orgDetails?.name}</h4>

                <form style={{display: "flex", flexDirection: "column"}}>
                  <div style={{  width: "50%", marginBottom: "20px" }}>
                    <CustomDataTable
                      columns={serviceColumns(index)}
                      data={newBill?.bills}
                      highlightOnHover
                      header="Services"
                      striped
                      responsive
                      pointerOnHover
                      dense
                      pagination={false}
                      defaultSortField="id"
                    />
                    <br />
                  </div>

                  <div style={{ display: "flex", width: "50%",alignItems: "flex-start" }}>
                    {/* Left summary */}
                    <table style={{ borderCollapse: "collapse", minWidth: "250px" }}>
                      <tbody>
                        <tr>
                          <td style={{ fontWeight: "bold", padding: "4px 8px", whiteSpace: "nowrap" }}>Amount (Incl. Tax):</td>
                          <td style={{ padding: "4px 8px" }}>{newBill?.total || 0}</td>
                        </tr>
                        <tr>
                          <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Discount:</td>
                          <td style={{ padding: "4px 8px" }}>{newBill?.discount || 0}</td>
                        </tr>
                        <tr style={{ backgroundColor: "#f9f9f9" }}>
                          <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Today's Payment:</td>
                          <td style={{ padding: "4px 8px" }}>{((newBill?.total || 0) - (newBill?.discount || 0)).toFixed(2)}</td>
                        </tr>
                        { !billDetails.hasSpecial &&
                        (<tr>
                          <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Previous Payment:</td>
                          <td style={{ padding: "4px 8px" }}>
                            {Number(getpreviousOutstanding(newBill?.orgDetails?.name, index) - (newBill?.paidToPrevious || 0)).toFixed(2)}
                          </td>
                        </tr>
                        )}
                        {/*
                        <tr>
                          <td style={{ fontWeight: "bold", padding: "4px 8px" }}>To Pay:</td>
                          <td style={{ padding: "4px 8px" }}>
                            {((newBill?.total || 0) + Number(getpreviousOutstanding(newBill?.orgDetails?.name, index))
                            - (newBill?.discount || 0) - (newBill?.paidToCurrent || 0)  - (newBill?.paidToPrevious || 0)).toFixed(2)}
                          </td>
                        </tr>
                        */}
                      </tbody>
                    </table>

                  </div>
                </form>
              </div>
            </div>
          )
        )}
      </div>
    </div>

    {/* ── Confirm modal ── */}
    {confirmModal && (
      <div style={{
        position: 'fixed', inset: 0, zIndex: 100000,
        background: 'rgba(0,0,0,0.65)', backdropFilter: 'blur(3px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <div style={{
          background: '#fff', borderRadius: 18, padding: '36px 32px',
          maxWidth: 440, width: '90%', boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
          display: 'flex', flexDirection: 'column', gap: 28,
          animation: 'confirmPop 0.22s cubic-bezier(0.34,1.56,0.64,1)',
        }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
            <span style={{ fontSize: 36, lineHeight: 1 }}>⚠️</span>
            <div>
              <div style={{ fontSize: 17, fontWeight: 700, color: '#1e293b', marginBottom: 8 }}>
                Billing Confirmation
              </div>
              <div style={{ fontSize: 16, color: '#475569', lineHeight: 1.6 }}>
                {confirmModal.msg}
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
            <button
              onClick={() => handleConfirmResolve(false)}
              style={{
                padding: '12px 24px', borderRadius: 10, border: '2px solid #cbd5e1',
                background: '#f8fafc', color: '#475569', fontSize: 16, fontWeight: 600,
                cursor: 'pointer',
              }}
            >Cancel</button>
            <button
              onClick={() => handleConfirmResolve(true)}
              style={{
                padding: '12px 28px', borderRadius: 10, border: 'none',
                background: '#2563eb', color: '#fff', fontSize: 16, fontWeight: 700,
                cursor: 'pointer', boxShadow: '0 4px 12px rgba(37,99,235,0.35)',
              }}
            >Confirm</button>
          </div>
        </div>
      </div>
    )}

    {/* ── Toast notifications ── */}
    {toast && (
      <div style={{
        position: 'fixed', bottom: 32, right: 32, zIndex: 99999,
        display: 'flex', alignItems: 'center', gap: 14,
        padding: '18px 24px', borderRadius: 14,
        maxWidth: 460, minWidth: 280, minHeight: 68,
        boxShadow: '0 8px 32px rgba(0,0,0,0.32)',
        color: '#fff', fontSize: 17, lineHeight: 1.5, fontWeight: 600,
        background: toast.type === 'error' ? '#dc2626'
          : toast.type === 'warning' ? '#d97706'
          : toast.type === 'success' ? '#16a34a'
          : '#1d4ed8',
        animation: 'slideInToast 0.28s cubic-bezier(0.34,1.56,0.64,1)',
      }}>
        <span style={{ fontSize: 26, lineHeight: 1, flexShrink: 0 }}>
          {toast.type === 'error' ? '✕' : toast.type === 'warning' ? '⚠' : toast.type === 'success' ? '✓' : 'ℹ'}
        </span>
        <span style={{ flex: 1 }}>{toast.msg}</span>
      </div>
    )}

    {/* Inline CSS (move to .css file if desired) */}
   <style jsx>{`
@keyframes slideInToast { from { opacity: 0; transform: translateY(16px) scale(0.96); } to { opacity: 1; transform: translateY(0) scale(1); } }
@keyframes confirmPop { from { opacity: 0; transform: scale(0.92); } to { opacity: 1; transform: scale(1); } }

  /* Overlay */
  .billing-drawer-overlay {
    display: none;
  }
  .billing-drawer-overlay.open {
    display: none;
  }

  /* Drawer */
  .billing-drawer {
    position: fixed;
    right: 0;
    top: 33px;
    height: calc(100vh - 68px);
    width: 540px;
    max-width: 94vw;
    background: #fff;
    transform: translateX(100%);
    transition: transform 300ms cubic-bezier(.2,.8,.2,1);
    box-shadow: -8px 0 24px rgba(0,0,0,0.1);
    z-index: 999;
    display: flex;
    flex-direction: column;
    font-family: "Inter", sans-serif;
  }
  .billing-drawer.open {
    transform: translateX(0);
  }

  /* Header */
  .drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    border-bottom: 1px solid var(--border-light);
  }
  .drawer-title h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: var(--text-main);
  }
  .drawer-sub {
    font-size: 11px;
    color: var(--text-sub);
  }
  .btn-close {
    background: #f0f1f3;
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    font-size: 18px;
    cursor: pointer;
    color: #555;
  }

  /* Body */
  .drawer-body {
    padding: 10px 14px;
    overflow-y: auto;
    flex: 1;
    background: #fafbfc;
  }

  /* Modern Card */
  .card {
    background: #fff;
    color: black;
    border-radius: var(--radius);
    border: 1px solid var(--border-light);
    padding: 10px 12px;
    margin-bottom: 10px;
    box-shadow: var(--shadow-soft);
  }

  /* Summary single-row grid */
  .summary-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 6px;
  }
  .summary-box {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 6px 8px;
    text-align: center;
  }
  .summary-box-label {
    font-size: 9px;
    color: #6b7280;
    font-weight: 500;
    margin-bottom: 2px;
    white-space: nowrap;
  }
  .summary-box-value {
    font-size: 13px;
    font-weight: 700;
    color: #1e293b;
  }
  .summary-box-total {
    background: #eef2ff;
    border-color: #c7d2fe;
  }
  .net-card .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
    font-size: 13px;
    border-bottom: 1px solid #f4f4f4;
  }
  .net-card .row:last-child {
    border-bottom: none;
  }
  .net-card .row.highlight {
    background: #f0f4ff;
    border-radius: 6px;
    padding: 7px 10px;
    font-weight: 700;
    border-bottom: none;
    margin-top: 3px;
  }
  .label {
    color: #555;
    font-size: 13px;
  }
  .value {
    color: #1e293b;
    font-weight: 600;
    font-size: 14px;
  }

  /* Section title */
  .section-title {
    font-weight: 700;
    font-size: 14px;
    margin-bottom: 8px;
    color: var(--text-main);
    display: flex;
    align-items: center;
    gap: 6px;
  }

  /* Payment Row */
  .payment-row {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 2px;
    background: #f8fafc;
    border: 1px solid #e8edf2;
    border-radius: 8px 8px 0 0;
    padding: 6px 8px;
  }
  .payment-row + .amount-words {
    margin-bottom: 6px;
    border-radius: 0 0 8px 8px;
    background: #f8fafc;
    border: 1px solid #e8edf2;
    border-top: none;
    padding: 1px 8px 4px 8px;
  }

  .btn-remove {
    background: transparent;
    border: none;
    cursor: pointer;
    color: #c62828;
    font-weight: 700;
    font-size: 15px;
    line-height: 1;
    padding: 0;
  }

  .payment-row select {
    padding: 6px 8px;
    border-radius: 6px;
    border: 1.5px solid #c7d2fe;
    font-size: 13px;
    background: #fff;
    color: #3730a3;
    font-weight: 600;
    width: 72px;
    flex-shrink: 0;
  }

  .payment-row input {
    padding: 6px 8px;
    border-radius: 6px;
    border: 1.5px solid #a5f3fc;
    font-size: 14px;
    font-weight: 700;
    text-align: right;
    background: #fff;
    color: #0e7490;
    width: 90px;
    flex: 1;
    min-width: 70px;
  }

  .amount-words {
    font-size: 11px;
    color: #94a3b8;
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Add Mode / Total Received */
  .payments-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
  }
  .btn-add {
    padding: 6px 14px;
    background: #eff6ff;
    border-radius: 8px;
    border: 1.5px solid #bfdbfe;
    font-weight: 700;
    font-size: 12px;
    cursor: pointer;
    color: #1d4ed8;
  }
  .btn-add:hover {
    background: #dbeafe;
  }
  .total-received .label {
    font-size: 13px;
    color: #555;
  }
  .total-received .value {
    font-weight: 700;
    font-size: 16px;
    color: #111;
  }

  /* UPI QR Card */
  .upi-qr-card {
    margin-top: 16px;
    background: #fff;
    border-radius: 10px;
    padding: 16px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  }
  .upi-header {
    margin-bottom: 12px;
  }
  .upi-footer {
    margin-top: 12px;
    font-size: 11px;
    color: #888;
  }

  /* QR panel — inline within drawer */
.upi-qr-slide {
  display: none;
}
.upi-qr-slide.open {
  display: block;
  margin-top: 14px;
  background: #f0fdf4;
  border: 1.5px solid #86efac;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
}

.upi-qr-slide .upi-header {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 12px;
}

.upi-qr-slide .upi-footer {
  margin-top: 16px;
  font-size: 12px;
  color: #666;
  text-align: center;
}

  /* Legacy Quick Received */
  .legacy-received {
    background: #f8fafc;
    padding: 14px 16px;
    border-radius: 10px;
    border: 1px solid #e8edf2;
    margin-top: 0;
  }

  .legacy-received .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }
  .legacy-received .label {
    font-size: 13px;
    font-weight: 600;
    color: #475569;
  }
  .legacy-received .input-amount-compact {
    width: 130px;
    text-align: right;
    padding: 8px 10px;
    border-radius: 8px;
    border: 1.5px solid #6366f1;
    font-size: 15px;
    font-weight: 700;
    background: #fff;
    color: #1e293b;
  }

  .select-mode,
  .input-amount {
    padding: 10px 12px;
    border-radius: 10px;
    border: 1px solid var(--border-light);
    background: #fff;
    font-size: 14px;
  }

  .select-mode {
    width: 35%;
  }
  .input-amount {
    width: 45%;
    text-align: right;
  }

  /* Payments actions */
  .payments-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
  }
  .btn-add {
    padding: 8px 12px;
    border-radius: 8px;
    background: var(--bg-soft);
    border: 1px solid var(--border-light);
    cursor: pointer;
    font-weight: 600;
  }

  /* Allocation Table */
  .alloc-table-wrap {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e8e8e8;
  }
  .alloc-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    table-layout: fixed;
  }
  .alloc-table th {
    background: #f5f6f8;
    padding: 9px 10px;
    color: #555;
    font-size: 12px;
    font-weight: 700;
    border-bottom: 1px solid #e0e0e0;
  }
  .alloc-table th:first-child  { text-align: left;  width: 28%; }
  .alloc-table th:nth-child(2) { text-align: right; width: 30%; }
  .alloc-table th:nth-child(3) { text-align: right; width: 42%; }
  .alloc-table td {
    padding: 8px 10px;
    border-bottom: 1px solid #f0f0f0;
    vertical-align: middle;
  }
  .alloc-table td:first-child  { text-align: left; }
  .alloc-table td:nth-child(2) { text-align: right; }
  .alloc-table td:nth-child(3) { text-align: right; }
  .input-alloc {
    width: 90px;
    padding: 6px 8px;
    text-align: right;
    border-radius: 6px;
    border: 1.5px solid #d0d5dd;
    font-size: 13px;
    font-family: inherit;
    background: #fff;
  }
  .input-alloc:focus {
    outline: none;
    border-color: #6366f1;
  }

  .totals-row {
    font-weight: 700;
    background: #f8f8f8;
  }
  .totals-row.mismatch {
    background: #fff0f0;
    color: #c62828;
  }

  .warn {
    margin-left: 4px;
    font-size: 12px;
  }

  /* Compact amount input (used in net-card) */
  .input-amount-compact {
    width: 130px;
    padding: 7px 10px;
    border-radius: 8px;
    border: 1.5px solid #d0d5dd;
    text-align: right;
    font-size: 14px;
    font-family: inherit;
    background: #fff;
    color: #1e293b;
  }
  .input-amount-compact:focus {
    outline: none;
    border-color: #6366f1;
  }
  .subtext {
    margin-top: 8px;
    color: #888;
    font-size: 11px;
    font-style: italic;
  }

  /* Footer */
  .drawer-footer {
    padding: 16px;
    background: #fff;
    border-top: 1px solid var(--border-light);
  }

  .footer-actions {
    display: flex;
    gap: 12px;
  }
  .btn {
    flex: 1;
    padding: 12px 14px;
    border-radius: 10px;
    font-weight: 700;
    font-size: 15px;
    cursor: pointer;
    border: none;
  }
  .whatsapp {
    background: #1faa59;
    color: #fff;
  }
  .print {
    background: #2f2f2f;
    color: #fff;
  }

  /* Page content — sits below the drawer so billing summary is always accessible */
  .page-content {
    top: 3px;
    position: relative;
    z-index: 1;
    margin-right: 550px;
    padding: 7px;
    padding-bottom: 100px;
    min-height: calc(100vh - 68px);
    overflow-y: auto;
  }

  @media (max-width: 768px) {
    .billing-drawer {
      width: 50%;
      border-radius: 0;
      height: calc(100vh - 68px);
    }

    .upi-qr-slide.open {
      display: block;
    }

    .page-content {
      margin-right: 0;
      padding-bottom: 100px;
    }
  }
`}</style>

  {/* UPI QR Modal */}
  {showUpiModal && (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setShowUpiModal(false)}>
      <div style={{ background: '#fff', borderRadius: 16, padding: '28px 36px', minWidth: 340, maxWidth: 420, textAlign: 'center', boxShadow: '0 12px 40px rgba(0,0,0,0.2)' }} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 4, color: '#166534' }}>💳 Scan to Pay</div>
        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 16 }}>UPI Payment</div>
        <UpiPaymentQR
          upid={billDetails?.orgDetails?.upid || selectedPatient?.orgDetails?.upid || "9891043444@ptyes"}
          amt={(() => {
            const upiPmt = payments.find(p => p.mode === "UPI");
            const otherPaid = payments.filter(p => p.mode !== "UPI").reduce((sum, p) => sum + Number(p.amount || 0), 0);
            const bal = Math.max(0, Number(billDetails?.total || 0) + getTotalPreviousOutstanding() - otherPaid);
            return (upiPmt && Number(upiPmt.amount) > 0) ? Number(upiPmt.amount) : bal;
          })()}
        />
        <div style={{ marginTop: 12, fontSize: 11, color: '#9ca3af' }}>Powered by UPI · Instant Confirmation</div>
        <button onClick={() => setShowUpiModal(false)} style={{ marginTop: 16, padding: '8px 24px', borderRadius: 8, border: 'none', background: '#e2e8f0', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>Close</button>
      </div>
    </div>
  )}

  </>
);

}

export default BillPrintReport;